var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8MicrosoftStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1edd5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(6.4,6.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 11.5,
    width: 33,
    height: 4,
    fill: "#c5d4de",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3.5,
    width: 10,
    height: 3,
    fill: "#c5d4de",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 11.5,
    width: 33,
    height: 4,
    fill: "none",
    stroke: "#b0c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,3.5h-10",
    fill: "none",
    stroke: "#b0c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6.5h11",
    fill: "none",
    stroke: "#b0c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,15.5v-9l-3,-2.5v11.5h-11v-11.5l-3,2.5v9h-8v19c0,1.105 0.895,2 2,2h29c1.105,0 2,-0.895 2,-2v-19z",
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,15.5v-9l-3,-2.5v11.5h-11v-11.5l-3,2.5v9h-8v19c0,1.105 0.895,2 2,2h29c1.105,0 2,-0.895 2,-2v-19z",
    fill: "none",
    stroke: "#e1ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 20.5,
    width: 4.5,
    height: 4.5,
    fill: "#f78f8f",
    stroke: "#c74343"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20.5,
    width: 4.5,
    height: 4.5,
    fill: "#bae0bd",
    stroke: "#5e9c76"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 27,
    width: 4.5,
    height: 4.5,
    fill: "#8bb7f0",
    stroke: "#4e7ab5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 4.5,
    height: 4.5,
    fill: "#ffeea3",
    stroke: "#f5ce85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MicrosoftStore);
export default __webpack_public_path__ + "static/media/icons8-microsoft-store.8e599f72c239ba7403c6fed2f9a6d3d4.svg";
export { ForwardRef as ReactComponent };